export default "__VITE_ASSET__C7SMPfph__"